import React from 'react'
import { IconsProps } from 'msp-integrations'

const UserIcon = (props: IconsProps) => {
  return (
    <svg
      {...props}
      width={props?.width || '78'}
      height={props?.height || '83'}
      viewBox='30 28 81 82'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M108.95 108.74c-4.94-16.76-20.6-28.46-38.08-28.46s-33.14 11.7-38.08 28.46l-.14.48-3.83-1.14.14-.48c4.85-16.46 19.38-28.75 36.41-30.95-2.79-2.08-5.69-4.84-7.47-6.72-6.01-6.38-8.93-12.97-8.92-20.17.02-11.92 9.84-21.66 21.91-21.73.19-.01.38-.01.58-.01 5.55 0 10.88 2.25 15 6.35 4.07 4.05 6.32 9.44 6.32 15.17 0 6.73-3.8 15.22-9.23 20.65-.04.04-3.79 3.75-7.34 6.43 17.11 2.13 31.72 14.44 36.59 30.98l.14.48-3.83 1.14-.17-.48zM70.9 32.04c-9.87.05-17.91 8.01-17.93 17.73-.01 6.12 2.55 11.82 7.83 17.42 4.49 4.75 9.04 7.93 10.06 8.21.88-.31 5.07-3.27 9.85-8.03 4.67-4.66 8.06-12.15 8.06-17.82 0-4.66-1.82-9.04-5.14-12.33-3.35-3.34-7.84-5.18-12.63-5.18h-.1z' />
    </svg>
  )
}

export default UserIcon
